import {ListItemText} from '@mui/material'
import {
  StyledArrowDropdownIcon,
  StyledBox,
  StyledPopover,
  StyledTypography,
  StyledListItem,
  StyledEducationListItemBox,
  StyledNoDataTypography,
  StyledList,
  StyledCircleIcon
} from './Styles'
import {useMemo, useState} from 'react'
import PropTypes from 'prop-types'
import {getShowPopperArrow} from '../../Campaigns/ProspectSegmentation/AllProspects/helpers'

const EducationPopover = ({
  content,
  columnKey,
  anchorEl,
  openPopover,
  handlePopoverOpen,
  handlePopoverClose,
  clickedColumn
}) => {
  const [deduplicatedEducationSummary, setDeduplicatedEducationSummary] = useState([])

  const removeDuplicatedEducationSummary = useMemo(() => {
    if (!content?.educationSummary) return []

    const removeDuplicateRecords = content.educationSummary.map((item) => ({
      ...item,
      degreeCollegeMapping: Array.from(
        new Map(
          item.degreeCollegeMapping.map((mapping) => [
            JSON.stringify({college: mapping.college, degree: mapping.degree}),
            mapping
          ])
        ).values()
      )
    }))
    setDeduplicatedEducationSummary(removeDuplicateRecords)
    return removeDuplicateRecords
  }, [content?.educationSummary])

  // Check if dropdown should be shown
  const shouldShowDropdown =
    getShowPopperArrow(content?.educationSummary, columnKey) &&
    removeDuplicatedEducationSummary?.some((item) => item.degreeCollegeMapping.some((mapping) => mapping[columnKey]))

  // Wrapper to pass deduplicated data to handlePopoverOpen
  const handlePopoverOpenWithDeduplicatedData = (event) => {
    handlePopoverOpen(event, removeDuplicatedEducationSummary, columnKey)
  }

  const isNoData = typeof content[columnKey] === 'string' && content[columnKey].startsWith('No data found')
  const TextComponent = isNoData ? StyledNoDataTypography : StyledTypography

  return (
    Object.hasOwn(content, columnKey) &&
    !isOnlyClassYear(content[columnKey]) && (
      <>
        <TextComponent
          component="span"
          onClick={shouldShowDropdown ? handlePopoverOpenWithDeduplicatedData : undefined}
          sx={shouldShowDropdown ? {cursor: 'pointer'} : {}}
        >
          {content[columnKey]}
        </TextComponent>
        {getShowPopperArrow(content?.educationSummary, columnKey) && (
          <StyledArrowDropdownIcon onClick={handlePopoverOpenWithDeduplicatedData} />
        )}
        <StyledPopover
          open={openPopover && columnKey === clickedColumn}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
        >
          <StyledBox>
            <StyledList>
              {deduplicatedEducationSummary?.length > 0 &&
                deduplicatedEducationSummary.map((eduEntry) =>
                  eduEntry.degreeCollegeMapping
                    .filter((mapping) => mapping[columnKey])
                    .map((mapping, index) => (
                      <StyledListItem key={`${eduEntry.classYear}-${index}`}>
                        <ListItemText
                          primary={
                            <StyledEducationListItemBox>
                              {eduEntry.classYear}
                              {eduEntry.classYear && mapping[columnKey] && <StyledCircleIcon />}
                              {mapping[columnKey]}
                            </StyledEducationListItemBox>
                          }
                        />
                      </StyledListItem>
                    ))
                )}
            </StyledList>
          </StyledBox>
        </StyledPopover>
      </>
    )
  )
}

const isOnlyClassYear = (value) => {
  if (!value || typeof value !== 'string') return false
  // Match patterns like: (1983), 1983, (1983), etc.
  const classYearPattern = /^\(?\d{4}\)?$/
  return classYearPattern.test(value.trim())
}

EducationPopover.propTypes = {
  content: PropTypes.object,
  columnKey: PropTypes.string,
  handlePopoverOpen: PropTypes.func,
  openPopover: PropTypes.bool,
  anchorEl: PropTypes.object,
  handlePopoverClose: PropTypes.func,
  clickedColumn: PropTypes.string
}

export default EducationPopover
